import { auth } from '@/lib/firebase';
import { onAuthStateChanged, signOut, User } from 'firebase/auth';
import { create } from 'zustand';

interface AuthState {
    user: User | null;
    isLoading: boolean;
    isLoggedIn: boolean;
    setUser: (user: User | null) => void;
    logout: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => {
    // Set up the listener immediately
    // Note: In a real React app, you often want to do this in an effect or initializer,
    // but doing it here ensures the store attempts to verify auth state as early as possible.
    // However, avoid side-effects in top-level execution if possible.
    // We will perform the subscription strictly here, assuming this file is imported once.

    const initialUnsubscribe = onAuthStateChanged(auth, (user) => {
        set({ user, isLoggedIn: !!user, isLoading: false });
    });

    return {
        user: null,
        isLoading: true,
        isLoggedIn: false,
        setUser: (user) => set({ user, isLoggedIn: !!user }),
        logout: async () => {
            await signOut(auth);
            set({ user: null, isLoggedIn: false });
        },
    };
});
